<template>
  <div class="confirmed-visit">
    <p v-if="$route.path.includes('new') || $route.path.includes('no_auth')">
      Twoja wizyta u wybranego Partnera Serwisowego
      <span>
        została zarezerwowana.
      </span>
      Dziękujemy!
    </p>
    <p v-else>
      Twoja wizyta została
      <span>
        zaktualizowana.
      </span>
      Dziękujemy!
    </p>
    <div class="registered-visit-container">
      <div class="visit-created-wrapper">
        <standard-button
          v-if="!withoutLogin"
          custom-class="visit-created-button"
          @buttonClick="$router.push({ path: '/dashboard/mycars' })"
          text="Zakończ"
        />
        <div v-else>
          <p>
            Czy chcesz
            <span>
              założyć konto
            </span>
            i przypisać do niego wizytę oraz wskazany samochód?
          </p>
          <div class="new-account-buttons">
            <standard-button
              text="Chcę założyć konto"
              @buttonClick="$router.push({
                path: '/',
                query: {
                  visit: true,
                },
              })"
              text-color="white"
            />
            <standard-button
              text="Zakończ"
              @buttonClick="$router.push({ path: '/' })"
              class-type="secondary"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StandardButton from '~/StandardButton';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    StandardButton,
  },
  computed: {
    ...mapGetters({
      showModal: 'modal/showModal',
    }),
    withoutLogin() {
      return this.$route.path.includes('no_auth');
    },
  },
  methods: {
    ...mapActions({
      loadSavedData: 'visit/loadSavedData',
    }),
    goToDashboard() {
      this.$router.push({ path: '/dashboard/mycars' });
    },
    newVisit() {
      this.router.push({
        path: '/',
        query: {
          visit: true,
        },
      });
    },
    handleKeyDown(event) {
      const { keyCode } = event;

      if (!this.showModal) {
        if (!this.withoutLogin) {
          if (keyCode === 13) {
            this.goToDashboard();
          }
        } else if (keyCode === 13) {
          this.newVisit();
        }
      }
    },
  },
  mounted() {
    this.loadSavedData();
    document.addEventListener('keydown', this.handleKeyDown, false);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
};
</script>
